// extracted by mini-css-extract-plugin
export default {"itemGroupImage":"ItemGroupImage_itemGroupImage__iHZyA","imtemGroupImageImgElement":"ItemGroupImage_imtemGroupImageImgElement__MO3hu"};